import { useCallback, useEffect } from 'react'
import { useLazyQuery, useQuery, useReactiveVar } from '@apollo/client'
import { useOktaAuth } from '@okta/okta-react'

import {
  activeArtistVar,
  countryCodeVar,
  currentUserVar,
  isLoadingVar,
  labelCodeIdVar,
  showMyFilterForZoneVar,
} from 'modulesCommon/store'
import { GET_USER_BY_EMAIL, SHOW_MY_FILTER_FOR_ZONE } from 'modulesCommon/graphql/queries'
import { useLoading, useServerError } from 'shared/hooks'

const useHeader = () => {
  const { oktaAuth, authState } = useOktaAuth()

  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const countryCode = useReactiveVar(countryCodeVar)
  const isLoading = useReactiveVar(isLoadingVar)
  const activeArtist = useReactiveVar(activeArtistVar)

  const onLogout = useCallback(async () => oktaAuth.signOut(), [oktaAuth])

  const {
    data: userData,
    error: userError,
    loading: userLoading
  } = useQuery(GET_USER_BY_EMAIL, {
    variables: { email: authState?.idToken?.claims.email || '' }
  })

  const [getMyFilters, { error: showMyFilterError, loading: showMyFilterLoading }] = useLazyQuery(
    SHOW_MY_FILTER_FOR_ZONE,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => showMyFilterForZoneVar(!!data?.showMyFilterForZone)
    }
  )

  useEffect(() => {
    if (currentLabelId) {
      getMyFilters({ variables: { zoneId: currentLabelId } })
    }
  }, [currentLabelId, getMyFilters])

  useEffect(() => {
    if (userData) {
      currentUserVar(userData?.findUserByEmail)
    }
  }, [userData])

  useLoading({ isLoading: userLoading || showMyFilterLoading })
  useServerError([userError, showMyFilterError])

  return {
    countryCode,
    onLogout,
    isLoading,
    activeArtist
  }
}

export default useHeader
